import { createSelector } from "reselect";

export const selectCrmData = state => state.crmData;

export const selectHasFormData = createSelector([selectCrmData], crmData =>
  crmData.nid ? true : false
);
